import React from 'react';

const variants = {
  primary:
    'bg-brand-red text-white hover:bg-brand-red-dark border border-brand-red',
  secondary:
    'bg-white text-brand-red border-2 border-brand-red hover:bg-red-50',
  gold: 'bg-brand-gold text-white hover:opacity-90 border border-brand-gold',
  outline:
    'bg-transparent text-gray-700 border border-gray-300 hover:border-brand-red hover:text-brand-red',
  ghost: 'bg-transparent text-brand-red hover:bg-red-50',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
};

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  ...props
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
